<div>
  <div ng-repeat="item in registro.objeto.selectedItems">
    {{item.descricao | capitalize}} -
    <span ng-if="item.tp_ocorrencia != 'inimigo_natural'" ng-style="{color: item.situacao.cor}">{{item.situacao.descricao}}</span>
    <span ng-if="item.tp_ocorrencia == 'inimigo_natural'" ng-style="{color: item.situacao.corInimigoNatural}">{{item.situacao.descricao}}</span>
  </div>

  <p ng-if="registro.objeto.evento">
    Evento: {{registro.objeto.evento.descricao}}
  </p>

  <p ng-if="registro.objeto.acao">
    Ação a ser realizada: {{registro.objeto.acao}}
  </p>

  <p ng-if="registro.objeto.temTarefa">
    Gerou tarefa para {{(registro.objeto.responsavel || {}).nome}}
  </p>

  <p ng-if="registro.objeto.situacao">
    Situação: {{registro.objeto.situacao}}
  </p>

  <p ng-if="!registro.objeto.evento && registro.objeto.dataInicial">
    Iniciando em {{registro.objeto.dataInicial | date: 'dd/MM/yyyy'}}
  </p>

  <p ng-if="!registro.objeto.evento && registro.objeto.dataFinal">
    Deve finalizar em {{registro.objeto.dataFinal | date: 'dd/MM/yyyy'}}
  </p>

  <p ng-if="registro.objeto.observacao">
    {{registro.objeto.observacao}}
  </p>

  <p ng-if="registro.dataRegistro">Data do Registro: {{registro.dataRegistro | date: 'dd/MM/yyyy'}}</p>
</div>

<script type="text/ng-template" id="boolean">
  <li>
    {{indicador.titulo | capitalize}}: {{indicador.valor1 ? 'Sim' : 'Não'}}
  </li>
</script>

<script type="text/ng-template" id="percentual">
  <span ng-if="indicador.valor1 && indicador.valor2">
    <li>{{indicador.descricao1 | capitalize}}: {{indicador.valor1}}</li>
    <li>{{indicador.descricao2 | capitalize}}: {{indicador.valor2}}</li>
    <li>{{indicador.titulo | capitalize}}: {{((indicador.valor2 / indicador.valor1) * 100) | number:0}}%</li>
  </span>
</script>

<script type="text/ng-template" id="texto">
  <li ng-if="indicador.valor1">
    {{indicador.titulo | capitalize}}: {{indicador.valor1}}
  </li>
</script>

<script type="text/ng-template" id="valor">
  <li ng-if="indicador.valor1">
    {{indicador.titulo | capitalize}}: {{indicador.valor1}}
  </li>
</script>
